import { getDateMoment } from "../../../../../../../utils/getDate"
import { UserInformationType } from "../../../../../../../utils/getUserInformation/models"
import {
  SchedulesListPostType,
  SchedulesSearchConditionType,
} from "../../../../models/list"
import { SchedulesSearchFormDataType } from "../../../../models/list/search"
import { convertSearchDataSubmit } from "../../modules/useApi/convertSearchDataSubmit"

export const setFormDataBasic = (
  searchCondition: SchedulesSearchConditionType,
): SchedulesSearchFormDataType => {
  const {
    arrivalDateTimeDate,
    countryToTravel,
    departureDateTimeDate,
    fullName,
    projectName,
  } = searchCondition
  const _arrivalDateTime = arrivalDateTimeDate || ""
  const _departureDateTime = departureDateTimeDate || ""
  return {
    ...searchCondition,
    arrivalDateTimeDate: getDateMoment(_arrivalDateTime),
    countryToTravel: countryToTravel,
    departureDateTimeDate: getDateMoment(_departureDateTime),
    fullName: fullName,
    projectName: projectName,
  }
}

export const getDataSubmitBasic = (
  searchCondition: SchedulesSearchConditionType,
  isPathnameSchedules: boolean,
  userInformation?: UserInformationType,
): SchedulesListPostType =>
  convertSearchDataSubmit({
    isPathnameSchedules,
    searchCondition: searchCondition,
    userInformation,
    values: setFormDataBasic(searchCondition),
  })
